import Loader from '@components/Loading/Loader.js';
import { UIDiv } from '@ui';

export default class BasePage extends UIDiv {
  constructor() {
    super();
    this.loader = new Loader();
    this.cleanupFunctions = [];
  }

  loadHandler = () => {
    this.loader.hide();
  };

  addCleanupFunction(func) {
    this.cleanupFunctions.push(func);
  }

  dispose() {
    this.cleanupFunctions.forEach(func => func());
    this.cleanupFunctions = [];
  }
}
